import React from 'react';
import CustomerDTO from '../dtos/CustomerDTO';
import CustomerStats from '../components/CustomerStats';
import SummaryInfoDTO from '../dtos/SummaryInfoDTO';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import SubjectInfoCard from './SubjectInfoCard';
import { CustomerType } from 'features/customer/enums/customerType';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useTranslation } from 'react-i18next';
import ContractCountDTO from 'features/dashboard/contracts/dtos/ContractCountDTO';

interface Props {
  customer: CustomerDTO;
  summaryInfo: SummaryInfoDTO;
  contractCounts: ContractCountDTO[];
}

const CustomerInfoCard = ({customer, summaryInfo, contractCounts }: Props): JSX.Element => {
  // translations
  const tLabels = useTranslation("customer\\customer").t;

   // helpers
   const getIcon = (customerType: CustomerType): IconProp => {
    switch (customerType) {
      case CustomerType.Company:
        return "building";
      case CustomerType.Person:
        return "user";
      default:
        return "ban";
    }
  }

  // sub-renders
  const renderSummaryInfo = () => { 
    return (
      <NoContentWrapper
        data={summaryInfo}
        loadStatus="AfterFirstLoad"
      >
        <hr className="my-4" />
        <CustomerStats 
          summaryInfo={summaryInfo} 
          contractCounts={contractCounts}
        />
      </NoContentWrapper>
    );
  }

  // render
  return (
    <SubjectInfoCard 
      subjectType={customer.customerType!}
      subjectTypeIcon={getIcon(customer.customerType!)}
      subjectName={customer.name!}
      subjectNumber={`${tLabels("customerInfoCard.customerNumber")}: ${customer.customerNumber}`}
      company={customer.company}
      person={customer.person}
      subjectAddress={customer.address!}
      renderOtherInfo={renderSummaryInfo}
      className="pb-0"
    />
  );
}

export default CustomerInfoCard;